import { IconButton, MenuItem, Select } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { setGlobal, setGlobalLoading } from 'store/global/reducer';
import styled from 'styled-components/macro';
import MenuIcon from '@material-ui/icons/Menu';
import { userRoles } from 'utility/lookup';
import HAIcon from 'assets/images/ha_icon.png';
import NotificationButton from './NotificationButton';
import { CLEAR_UP_REDUX, LOGOUT_USER, UPDATE_USER, CALL_LOGOUT_USER, FETCH_USER_MENU } from 'store/key';
import { useHistory } from 'react-router';
import useDialog from 'components/ConfirmDialog/useDialog';
import { getTimeWithTimeZone, updateIsRefreshToken } from 'utility/general';
import { LOGOUT_CONFIRM } from 'utility/frontendMessage';

import API from 'api/call';
import { KEYS, setItem } from 'storage';

const SLayout = styled.div`
    min-width: ${(props) => props.minWidth ?? '1280'}px;
`;

const SHAIcon = styled.img`
    height: 40px;
    margin-right: 10px;
`;

const SHeader = styled.div`
    display: flex;
    background: #15426b;
    color: #fff;
    justify-content: space-between;
    height: 60px;
    padding: 0 20px 0 10px;
`;

const SDrawerButtonLayout = styled.div``;

const STitleLayout = styled.div`
    display: flex;
    align-items: center;
`;

const SInfoLayout = styled.div`
    display: flex;
    align-items: center;
`;

const SUsernameLayout = styled.div`
    display: flex;
    font-size: 12;
    align-items: center;
`;

const SLogoutLayout = styled.div`
    color: #f6f6f6;
    cursor: pointer;
`;

const SEmailLayout = styled.div`
    font-size: 16px;
`;

const SNotificationLayout = styled.div`
    margin: 0 15px;
`;

const STitleText = styled.div`
    font-size: 18px;
    font-weight: bold;
`;

const SLastLoginLayout = styled.div`
    margin-top: 4px;
    font-size: 12px;
    display: flex;
`;

const SUserInfoLayout = styled.div`
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    margin-right: 25px;
    margin-top: 5px;
    flex-shrink: 0;
`;

const useStyles = makeStyles((theme) => ({
    select: {
        '&:before': {
            borderColor: 'white',
        },
        '&:hover:not(.Mui-disabled):before': {
            borderColor: 'white',
        },
        '&:after': {
            borderColor: 'white',
        },
    },
    icon: {
        fill: 'white',
    },
    root: {
        top: 200,
    },
}));

const RootHeader = ({ minWidth }) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const userDetail = useSelector((state) => state.user.detail);
    const classes = useStyles();
    const currentRole = useSelector((state) => state.user.role);
    const isShowDrawer = useSelector((state) => state.global.isShowDrawer);
    const showDialog = useDialog();
    const history = useHistory();

    const toggleDrawer = () => {
        dispatch(
            setGlobal({
                isShowDrawer: !isShowDrawer,
            }),
        );
    };

    const onUserLogout = async () => {
        const isConfirm = await showDialog({
            description: LOGOUT_CONFIRM,
        });

        if (!isConfirm) {
            return;
        }

        setGlobalLoading(true);

        dispatch({
            type: CALL_LOGOUT_USER,
            payload: {
                final: () => {
                    dispatch({
                        type: LOGOUT_USER,
                        payload: {
                            callback: () => {
                                history.push('/');
                                setGlobalLoading(false);
                            },
                        },
                    });
                },
            },
        });
    };

    const updateRole = async (e) => {
        const role = e.target.value;

        try {
            setGlobalLoading(true);
            // updateIsRefreshToken(true);

            const res = await API.user.changeRole({ roleToChange: role });

            const { token, refreshToken } = res?.data?.result;

            setItem(KEYS.ACCESS_TOKEN, token);
            setItem(KEYS.REFRESH_TOKEN, refreshToken);

            dispatch({
                type: UPDATE_USER,
                payload: {
                    role,
                },
            });

            dispatch({
                type: CLEAR_UP_REDUX,
            });

            history.push('/');

            dispatch({
                type: FETCH_USER_MENU,
                payload: {
                    // role: user.role,

                    callback: () => {
                        setGlobalLoading(false);
                    },
                },
            });

            updateIsRefreshToken(false);
        } catch (error) {
            console.log('172015 index.jsx error', error);
            updateIsRefreshToken(false);
            setGlobalLoading(false);
        }
    };

    const getUserFullName = () => {
        return `${user.detail?.firstName ?? ''} ${user.detail?.surname ?? ''}`;
    };

    return (
        <SLayout minWidth={minWidth}>
            <SHeader>
                <STitleLayout>
                    {user.isLogin && (
                        <SDrawerButtonLayout>
                            <IconButton onClick={toggleDrawer}>
                                <MenuIcon style={{ color: 'white' }} />
                            </IconButton>
                        </SDrawerButtonLayout>
                    )}
                    <SHAIcon src={HAIcon} />
                    <STitleText>HA Clinical Research Ethics Review Portal</STitleText>
                </STitleLayout>
                {user.isLogin && (
                    <SInfoLayout>
                        <SUsernameLayout>
                            <SUserInfoLayout>
                                <SEmailLayout>{getUserFullName()}</SEmailLayout>
                                <SLastLoginLayout>
                                    Last Login:
                                    <div style={{ marginLeft: 5 }}>
                                        {!userDetail?.lastLoginDtm
                                            ? '-'
                                            : getTimeWithTimeZone(userDetail.lastLoginDtm).format('YYYY-MM-DD HH:mm')}
                                    </div>
                                </SLastLoginLayout>
                            </SUserInfoLayout>

                            {(user?.roles?.length ?? 0) > 0 && (
                                <Select
                                    value={currentRole}
                                    onChange={updateRole}
                                    displayEmpty
                                    className={classes.select}
                                    style={{ color: '#fff' }}
                                    inputProps={{
                                        classes: {
                                            icon: classes.icon,
                                        },
                                    }}
                                    MenuProps={{
                                        style: {
                                            top: 50,
                                        },
                                    }}
                                >
                                    {user.roles.map((role) => {
                                        const displayName = userRoles
                                            .filter((item) => !item.isHidden)
                                            .find((item) => {
                                                return item.key === role;
                                            })?.display;

                                        if (!displayName) {
                                            return null;
                                        }

                                        return (
                                            <MenuItem key={role} value={role}>
                                                {displayName}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            )}

                            <SNotificationLayout>
                                <NotificationButton />
                            </SNotificationLayout>
                        </SUsernameLayout>
                        <SLogoutLayout onClick={onUserLogout}>Logout</SLogoutLayout>
                    </SInfoLayout>
                )}
            </SHeader>
        </SLayout>
    );
};

export default RootHeader;
